import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrderStoreSelector } from '@common/selectors/order.selector';
import { CartService } from '@core/services/cart/cart.service';

import {
  CartItemListBlockDataSource,
  CartItemListBlockViewModel,
} from './cart-item-list-block-view-model';

@Injectable()
export class CartItemListBlockStoreDataSource implements CartItemListBlockDataSource {
  private readonly cartService = inject(CartService);
  private readonly orderSelector = inject(OrderStoreSelector);

  readonly vm$: Observable<CartItemListBlockViewModel> = combineLatest([
    this.cartService.getCartLineItems$(),
    this.orderSelector.selectIsValidating$,
  ]).pipe(
    map(([reconstructedCart, isOrderValidationInProgress]) => ({
      reconstructedCart,
      isOrderValidationInProgress,
    })),
  );
}
